import types from "./types";

const initialState = {
  incidents: [],
  visibleIncidents: [],
  selectedIncidents: [],
  loaded: false,
  visible: true,
  queriedIncidentsTotal: 0,
  displayedIncidentsCount: 0
}

const incidentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INCIDENTS:
      return {
        ...state,
        incidents: (action.payload.incidents) ? action.payload.incidents : [],
        loaded: true
      }
    case types.SET_INCIDENTS_LOADED:
      return {
        ...state,
        loaded: action.payload.loaded
      }
    case types.SET_QUERIED_INCIDENTS_TOTAL:
      return {
        ...state,
        queriedIncidentsTotal: action.payload.queriedIncidentsTotal
      }
    case types.SET_DISPLAYED_INCIDENTS_COUNT:
      return {
        ...state,
        displayedIncidentsCount: action.payload.displayedIncidentsCount
      }

    case types.SET_INCIDENT_LIST_VISIBLE:
      return {
        ...state,
        visible: action.payload.visible
      };
    case types.SET_VISIBLE_INCIDENTS:
      return {
        ...state,
        visibleIncidents: (action.payload.incidents) ? action.payload.incidents : [],
        loaded: true
      }
    case types.ADD_SELECTED_INCIDENT:
      return {
        ...state,
        selectedIncidents: [...state.selectedIncidents, action.payload.incident]
      }
    case types.REMOVE_SELECTED_INCIDENT:
      return {
        ...state,
        selectedIncidents: [...state.selectedIncidents.filter(incident => incident.attributes.UniqueFireIdentifier !== action.payload.incident.attributes.UniqueFireIdentifier)]
      }
    case types.CLEAR_SELECTED_INCIDENTS:
      return {
        ...state,
        selectedIncidents: []
      }

    default:
      return state;
  }
}

export default incidentsReducer;
